module.exports = __webpack_public_path__ + "img/next_arrow.0ba22391.svg";